import DeliverableTransferModel       from '@/models/services/shop/DeliverableTransferModel';
import DeliverableTransferStatusModel from '@/models/services/shop/DeliverableTransferStatusModel';
import ShopServiceModel               from '@/models/ShopServiceModel';
import { computed }                   from 'mobx';
import dayjs                          from 'dayjs';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';

@model.urnResource('deliverable_transfer_status_history')
@doc.path('/deliverable_transfer_status_histories/{?id}')
export default class DeliverableTransferStatusHistoryModel extends ShopServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'deliverableTransfer': id;
		'deliverableTransfer.deliverable': id;
		'deliverableTransferStatus': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(DeliverableTransferModel) declare deliverableTransfer: DeliverableTransferModel;
	@doc.model(DeliverableTransferStatusModel) declare deliverableTransferStatus: DeliverableTransferStatusModel;

	@computed get createdAt() {
		return dayjs(this.get('createdAt', dayjs()));
	}
}